export default "__VITE_ASSET__CKi4Qbt0__"